import { render, staticRenderFns } from "./CancelAllocateSimCardsToAgency.vue?vue&type=template&id=e9b09234&"
import script from "./CancelAllocateSimCardsToAgency.vue?vue&type=script&lang=js&"
export * from "./CancelAllocateSimCardsToAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports